<app-ngx-mat-table
  tableName="{{ tableName }}"
  [description]="description"
  [dataType]="sourceType"
  sortActive="id"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
></app-ngx-mat-table>
<router-outlet></router-outlet>
